
import { Component, Vue } from 'vue-property-decorator';
import SelectedManufacturer from '../components/selected-manufacturer.vue';
import Dispatches from './dispatches.vue';

@Component({
    components: { SelectedManufacturer, Dispatches }
})
export default class DispatchesWrapper extends Vue {
    get hasBrand(): boolean {
        return !!this.$route.query.marca;
    }

    get marcaSeleccionada(): string {
        return this.$route.query.marca as string;
    }

    handleBrandSelected(brand: string) {
        this.$router.push({ query: { marca: brand } });
    }

    handleGoBack() {
        this.$router.replace({ query: {} });
    }
}
